import React from 'react';
import RadioSection from '../../Sections/RadioSection';
import DuplexSecondMeter from './DuplexSecondMeter';

class DuplexBuilding extends React.Component {
    render() {
        const p = this.props;
        return (
            <div>
                <RadioSection name="duplexMeterCount" {...window.osa.lookup.serviceAddress.duplexMeterCount} />
                {p.duplexMeterCount === "2" ? <DuplexSecondMeter address={p.address}/> : null}
            </div>
        );
    }
}
export default DuplexBuilding;